import React from 'react';

import AmountCalculatorController from '../../../apps/amountCalculator/AmountCalculatorController';

const AmountCalculatorBlock = ({ data }) => {
  const { heading, subheading, blockImage, formHeading } = data;

  return (
    <AmountCalculatorController
      heading={heading}
      subheading={subheading}
      formHeading={formHeading}
      backgroundImage={blockImage?.localFile?.childImageSharp?.fluid}
    />
  );
};

export default AmountCalculatorBlock;
